<template>
  <div class="user-modal-wrapper">
    <div
      class="user-modal"
      :class="{ 'user-modal-small': limitedFunctionality }"
    >
      <form>
        <section class="user-row">
          <!-- NAME -->
          <TheInput
            v-model="user.name"
            label="Име *"
            placeholder="Име"
            icon="B"
            :invalid="!isNameValid"
            @keyup="(isNameValid = true), formatName()"
          />
          <!-- NAME -->

          <TheInput
            v-model="user.unit"
            :label="`Звено ${
              user.permissions.isAllProjectsReporter ? '*' : ''
            }`"
            placeholder="Изберете звено"
            icon="B"
            :title="
              !user.permissions.isAllProjectsReporter &&
              'Само служители с роля “Отчетник всички обекти“ могат да имат звено'
            "
            :list="units"
            :disabled="!user.permissions.isAllProjectsReporter"
            prop="name"
            @clear="user.unit = ''"
          />
        </section>

        <section class="user-row">
          <TheInput
            v-model="user.username"
            label="Потребителско име *"
            placeholder="Потребителско име"
            icon="B"
            :invalid="!isUsernameValid"
            :disabled="limitedFunctionality"
            @keyup="(isUsernameValid = true), formatUsername()"
          />
          <TheInput
            v-model="user.password"
            label="Парола *"
            type="password"
            placeholder="Парола"
            icon="A"
            :invalid="!isPasswordValid"
            @keyup="isPasswordValid = true"
            autocomplete="new-password"
          />
        </section>

        <section class="user-row">
          <TheInput
            v-model="user.email"
            label="E-mail"
            placeholder="E-mail"
            icon="G"
            iconName="sienit2"
            :invalid="!isEmailValid"
            @keyup="isEmailValid = true"
          />
          <TheInput
            v-model="user.phone"
            label="Телефон"
            placeholder="Телефон"
            icon="G"
            iconName="sienit2"
          />
        </section>

        <template v-if="!limitedFunctionality && userMode">
          <section class="user-row">
            <TheInput
              v-model="user.position"
              label="Позиция"
              placeholder="Позиция"
              icon="Q"
              iconName="sienit2"
            />
            <TheInput
              v-model="user.company"
              label="ДРУЖЕСТВО СИЕНИТ"
              placeholder="ДРУЖЕСТВО СИЕНИТ"
              icon="P"
              iconName="sienit2"
              @clear="clearCompany()"
              :list="[
                'Сиенит Строителна Група АД',
                'Сиенит Инвест АД',
                'Сиенит Холдинг АД',
              ]"
            />
          </section>

          <section class="user-row">
            <TheInput
              v-model="user.substitute"
              label="Временно Заместващ служител"
              placeholder="Изберете служител"
              icon="B"
              iconName="sienit"
              @clear="clearSubstitute()"
              :list="forSubstitute"
              prop="name"
            />
            <TheInput
              v-model="user.substitutePeriod"
              label="Период на заместване (по желание)"
              placeholder="Изберете период (от-до)"
              icon="D"
              iconName="sienit"
            />
          </section>

          <div class="leave-wrapper">
            <label class="input-label"
              >Неизползван отпуск по години (дни)</label
            >
            <div class="leave-list">
              <div
                class="leave"
                v-for="(l, y, i) in user.leave"
                :key="`userLeave-${i}`"
              >
                <!-- LEAVE -->
                <label :for="`userLeave-${i}`" class="input-label">{{
                  y
                }}</label>
                <div class="input-wrapper input-wrapper--icon">
                  <span class="sienit2">F</span>
                  <input
                    :id="`userLeave-${i}`"
                    placeholder="Брой дни"
                    v-model="user.leave[y]"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- PERMISSIONS -->
          <label class="input-label">Разрешения ТМС</label>
          <div class="user-modal-permissions">
            <label
              class="checkbox-wrapper"
              v-if="getUser.permissions.isSuperAdmin"
            >
              Главен администратор
              <input
                type="checkbox"
                v-model="user.permissions.isSuperAdmin"
                @change="isNonWorkerChanged()"
              />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Администратор
              <input
                type="checkbox"
                v-model="user.permissions.isAdmin"
                @change="isNonWorkerChanged()"
              />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Отчетник
              <input
                type="checkbox"
                v-model="user.permissions.isReporter"
                @change="isNonWorkerChanged()"
              />
              <span class="checkmark"></span>
            </label>
            <!-- <label class="checkbox-wrapper">
              Изпълнител
              <input
                type="checkbox"
                v-model="user.permissions.isWorker"
                @change="isWorkerChanged()"
              >
              <span class="checkmark"></span>
            </label>-->
          </div>
          <label class="input-label">Разрешения Електронна администрация</label>
          <div class="user-modal-permissions user-modal-permissions--wrap">
            <label class="checkbox-wrapper">
              Изпълнителен директор
              <input type="checkbox" v-model="user.permissions.isCEO" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Човешки ресурси
              <input type="checkbox" v-model="user.permissions.isHR" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Ръководител Отпуски
              <input type="checkbox" v-model="user.permissions.isTechLead" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Ръководител всички отпуски
              <input type="checkbox" v-model="user.permissions.isLeadAll" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Административен персонал
              <input
                type="checkbox"
                v-model="user.permissions.isAdministrativeStaff"
                @input="user.permissions.isStaff = false"
              />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Работник
              <input
                type="checkbox"
                v-model="user.permissions.isStaff"
                @input="user.permissions.isAdministrativeStaff = false"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <label class="input-label"
            >Разрешения Разпределение на плащания</label
          >
          <div class="user-modal-permissions user-modal-permissions--wrap">
            <label
              class="checkbox-wrapper"
              v-for="(p, i) of paymentPermissions"
              :key="`${p}-${i}`"
              :title="p.title"
              @click="isFieldDisabled(p[1], true)"
            >
              {{ p.name }}

              <input
                type="checkbox"
                v-model="user.permissions[p.value]"
                :disabled="isFieldDisabled(p.value)"
                @input="
                  paymentPermissionsToggle(p.value, $event.target.checked)
                "
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </template>
        <div class="user-modal-actions">
          <div class="switches" v-if="!limitedFunctionality">
            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="user.isActive"
                  :disabled="user.isReleased"
                />
                <span class="slider"></span>
              </label>
              <label v-if="user.isActive">Активен</label>
              <label v-else>Неактивен</label>
            </div>
            <div class="switch-container" v-if="!user.permissions.isWorker">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="user.isReleased"
                  @change="makeReleased()"
                />
                <span class="slider"></span>
              </label>
              <label>Освободен</label>
            </div>
          </div>
          <div v-else>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button
              v-if="!idToEdit"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="register"
            >
              <span class="sienit">B</span>
              Създай
            </button>
            <button
              v-else
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="edit"
            >
              <span class="sienit">B</span>
              Редактирай
            </button>
            <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="sienit">F</span>
              Отказ
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import log from "../mixins/log.js";
import TheInput from "../shared/TheInput.vue";
export default {
  mixins: [log],
  props: ["idToEdit", "limitedFunctionality", "userMode"],
  components: {
    TheInput,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
  },
  data() {
    return {
      isUsernameValid: true,
      isPasswordValid: true,
      isNameValid: true,
      isEmailValid: true,
      units: [],
      forSubstitute: [],
      paymentPermissions: [
        {
          name: "Счетоводител",
          value: "isAccountant",
          title: `• Права да извършват плащания
• Виждат всички обекти, без да се добавят специално
• Могат да създават и редактират всички качени документи - и собствени и на всички останали
• Могат да създават документи с едни и същи номера за един доставчик
• Има право да качва един и същ номер документ към един доставчик няколко пъти, тъй като има общи фактури за повече от един обекта`,
        },
        {
          name: "Ръководител всички обекти",
          value: "isAllObjectsManager",
          title: `• има достъп и може да качва документи във всички обекти;
• може да редактира документи по всички обекти, независимо кой ги е качил;
• не може да отбелязва и коригира плащания
• Има право да качва един и същ номер документ към един доставчик няколко пъти, тъй като има общи фактури за повече от един обекта
    `,
        },
        {
          name: "Отчетник обект",
          value: "isObjectManager",
          title: `• Има право да качват документи само в обектите, където специално са добавени като Рък-л обект (отчетник)
• Вижда своите документи и документите качени от други ръководители в обектите до които има достъп
• Може да редактира само документите които лично е качил
    `,
        },
        {
          name: "Главен отчетник",
          value: "isAllProjectsManager",
          title: `• има достъп и може да качва документи във всички обекти;
• може да редактира документи по всички обекти, независимо кой ги е качил;
• не може да отбелязва и коригира плащания
    `,
        },
        {
          name: "Ръководител проект",
          value: "isProjectManager",
          title: `• има достъп и може да качва документи само в обектите, до които му е даден достъп
• Вижда и може да редактира всички документи по обектите, до които има достъп, независимо кой ги е качил;
• не може да отбелязва и коригира плащания.
    `,
        },
        {
          name: "Отчетник всички обекти",
          value: "isAllProjectsReporter",
          title: `• Само тази роля може да участва в "Звено"
• Може да качва документи по всички обекти
• Вижда и редактира само документите, които той е качил, също и документите, качени от останалите отчетници в същото звено
• Не вижда други документи в обектите, освен тези в собственото си звено
• не може да отбелязва и коригира плащания.
    `,
        },
      ],
      user: {
        username: "",
        password: "",
        email: "",
        name: "",
        position: "",
        phone: "",
        company: "",
        unit: "",
        isActive: true,
        isReleased: false,
        leave: {},
        permissions: {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: true,
          isWorker: false,
          isCEO: false,
          isHR: false,
          isTechLead: false,
          isLeadAll: false,
          isAccountant: false,
          isObjectManager: false,
          isAllObjectsManager: false,
          isAdministrativeStaff: false,
          isStaff: false,
          isAllProjectsManager: false,
          isProjectManager: false,
          isAllProjectsReporter: false,
        },
      },
    };
  },
  methods: {
    makeReleased() {
      if (this.user.isReleased) {
        const ask =
          "Ако отбележите служителя, че е освободен, отпуската му ще се нулира. Сигурни ли сте?";
        if (confirm(ask)) {
          this.user.isActive = false;
          this.user.company = "";
          for (let l in this.user.leave) {
            this.$set(this.user.leave, l, 0);
          }
        } else {
          this.$nextTick(() => {
            this.$set(this.user, "isReleased", false);
          });
        }
      }
    },
    isFieldDisabled(p, checkForError) {
      if (
        checkForError &&
        !this.units.length &&
        p === "isAllProjectsReporter"
      ) {
        return this.$snotify.error(
          "Първо създайте поне едно звено, преди да изберете тази роля"
        );
      }

      return !this.units.length && p === "isAllProjectsReporter";
    },
    paymentPermissionsToggle(p, checked) {
      if (p === "isAllProjectsReporter") {
        if (checked && !this.units.length) {
          this.$set(this.user.permissions, "isAllProjectsReporter", false);
          this.$snotify.error(
            "Първо създайте поне едно звено, преди да изберете тази роля"
          );
        } else if (!checked) delete this.user.unit;
      }
    },
    initLeave() {
      const year = new Date().getFullYear();
      for (let i = 0; i < 4; i++) {
        this.$set(this.user.leave, year - i, 0);
      }
    },
    getSpecificUser(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${id}`)
        .then((response) => {
          this.user = response.data;
          if (!this.user.leave) {
            this.user.leave = {};
            this.initLeave();
          }

          if (!this.user.unit) {
            this.$set(this.user, "unit", "");
          }
        });
    },
    getSubstituteUsers() {
      let url = `${process.env.VUE_APP_BASE_URI}/auth/users/for-substitute`;
      url += `/${this.idToEdit}`;

      this.$http.get(url).then((response) => {
        this.forSubstitute = response.data;
      });
    },
    clearSubstitute() {
      this.$set(this.user, "substitute", null);
    },
    clearCompany() {
      this.$set(this.user, "company", null);
    },
    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateUsername(username) {
      if (!username.length) {
        return false;
      }
      const re = /^[a-z0-9_.-]*$/;
      if (!username.match(re)) {
        return false;
      }
      return true;
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatUsername() {
      this.user.username = this.user.username
        .replace(/[^A-Za-z0-9-._]/g, "")
        .toLowerCase();
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatName() {
      this.user.name = this.user.name.replace(/[^А-Яа-я0-9 -._]/g, "");
    },
    isNonWorkerChanged() {
      if (
        this.user.permissions.isSuperAdmin ||
        this.user.permissions.isAdmin ||
        this.user.permissions.isReporter
      ) {
        this.user.permissions.isWorker = false;
      }
    },
    isWorkerChanged() {
      if (this.user.permissions.isWorker) {
        this.user.permissions.isSuperAdmin = false;
        this.user.permissions.isAdmin = false;
        this.user.permissions.isReporter = false;

        this.username = "";
        this.password = "";
      }
    },
    checkForm() {
      if (!this.user.name) {
        this.isNameValid = false;
        throw this.$snotify.error("Въведете име");
      }
      if (!this.user.permissions.isWorker) {
        if (!this.validateUsername(this.user.username)) {
          this.isUsernameValid = false;
          throw this.$snotify.error("Неправилно потребителско име");
        }
        if (!this.user.password && !this.idToEdit) {
          this.isPasswordValid = false;
          throw this.$snotify.error("Въведете парола");
        }
      }
      if (this.user.email) {
        if (this.user.email.length && !this.validateEmail(this.user.email)) {
          this.isEmailValid = false;
          throw this.$snotify.error("Неправилен мейл");
        }
      }
      if (this.user.permissions["isAllProjectsReporter"] && !this.user.unit) {
        throw this.$snotify.error(
          "Звеното е задължително за роля Отчетник всички обекти"
        );
      }
      // If everything is valid
      if (
        this.isUsernameValid &&
        this.isPasswordValid &&
        this.isNameValid &&
        this.isEmailValid
      ) {
        return true;
      }
      // if not
      return false;
    },
    register() {
      if (this.checkForm()) {
        if (!this.user.unit) delete this.user.unit;
        let userForRequest = this.user;
        // if (!userForRequest.email.length) {
        //   delete userForRequest.email;
        // }
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/auth/register`, userForRequest)
          .then(() => {
            this.$snotify.success("Успешно регистрирахте нов потребител!");
            this.newLog(
              "newUser",
              this.user.permissions.isWorker
                ? this.user.name
                : this.user.username
            );
            this.closeModal(true);
          })
          .catch((error) => {
            if (error.response.data)
              this.$snotify.error(error.response.data.error);
            else this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.$http
          .put(
            `${process.env.VUE_APP_BASE_URI}/auth/users/${this.idToEdit}`,
            this.user
          )
          .then((res) => {
            this.$snotify.success("Промените са записани успешно!");
            // IF THE CURRENTLY LOGGED USER CHANGED HIS OWN ROLE IT LOGGES HIM OUT
            if (this.idToEdit === this.$store.state.user._id) {
              const oldPermissions = this.$store.state.user.permissions;
              const newPermissions = res.data.user.permissions;
              if (
                !(
                  oldPermissions.isSuperAdmin === newPermissions.isSuperAdmin &&
                  oldPermissions.isAdmin === newPermissions.isAdmin &&
                  oldPermissions.isReporter === newPermissions.isReporter &&
                  oldPermissions.isWorker === newPermissions.isWorker &&
                  this.$store.state.user.isActive === res.data.user.isActive &&
                  this.$store.state.user.isReleased === res.data.user.isReleased
                )
              ) {
                this.$store
                  .dispatch("logout")
                  .then(() => this.$router.push("/login"))
                  .catch((err) => console.log(err));
              }
            }
            this.newLog(
              "editUser",
              this.user.permissions.isWorker
                ? this.user.name
                : this.user.username
            );
            this.closeModal(true);
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response.data)
              this.$snotify.error(error.response.data.error);
            else this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$parent.$emit("closeUserModal", { isEdited: isEdited });
    },
    getUnits() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/units`)
        .then((res) => {
          this.units = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    document.body.classList.add("stop-scrolling");
    this.initLeave();

    this.getUnits();
    this.getSubstituteUsers();

    if (this.idToEdit) {
      this.getSpecificUser(this.idToEdit);
    } else {
      if (this.userMode) {
        this.user.permissions = {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: true,
          isWorker: false,
        };
      } else {
        this.user.permissions = {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: false,
          isWorker: true,
        };
      }
    }

    if (this.idToEdit === this.$store.state.user._id) {
      if (this.limitedFunctionality) {
        this.$snotify.warning(
          "Внимание! При редакция на профила ви ще бъдете разлогнати от системата и ще трябва да влезете отново."
        );
      } else {
        this.$snotify.warning(
          "Внимание! Ако промените някое от собствените ви разрешения (за ТМС) или статус ще бъдете разлогнати от системата."
        );
      }
    }
  },
  destroyed() {
    document.body.classList.remove("stop-scrolling");
  },
};
</script>

<style scoped lang="scss">
.user-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.user-modal {
  background-color: #fbfaf5;
  border-radius: 4px;
  border-top: 10px solid #942b10;
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  max-height: 90vh;
  overflow: auto;
  padding: 10px 0 80px;
  position: relative;
  /* width: 800px; */
}
.user-modal form {
  max-height: 80vh;
  padding: 0 20px;
  overflow: auto;
  overflow-x: hidden;
}
.user-modal .user-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.user-modal .input-wrap {
  width: 49%;
}
.user-modal-small {
  width: 600px;
}
.user-modal-permissions {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d8d2bd;
  display: flex;
  justify-content: center;

  &.user-modal-permissions--wrap {
    flex-wrap: wrap;

    label {
      width: 25%;
    }
  }
}
.user-modal-actions {
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  left: 0;
  position: absolute;
  width: 100%;
}
.invalid .sienit {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.new-input-wrapper {
  width: 100%;
}
.new-input {
  margin: 0;
}
.input-label {
  font-size: 13px;
}
.new-input-dropdown {
  transform: scaleY(0);
  transform-origin: top;
}
.new-input-dropdown-active {
  top: calc(100% + 10px);
  transform: scaleY(1);
  height: initial;
}
.leave-wrapper {
  padding-bottom: 10px;
  margin-top: 10px;
}
.leave-list {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 900px;
}

.leave {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(25% - 10px);
}

.switches {
  display: flex;
}
.switches .switch-container:not(:first-child) {
  margin-left: 20px;
}

.checkbox-wrapper {
  line-height: 12px;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .user-modal {
    width: 90%;
  }
}
@media screen and (max-width: 800px) {
  .user-modal {
    padding-bottom: 120px;
  }
  .user-modal .user-row {
    flex-direction: column;
  }
  .user-modal .user-row .input-wrap {
    width: 100%;
  }
  .user-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switches {
    align-items: center;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .btns {
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .user-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-width: 700px) {
  .user-modal.user-modal-small {
    width: 90%;
  }
}
@media screen and (max-height: 550px) {
  .user-modal {
    height: 100%;
  }
  .user-modal.user-modal-small {
    height: 68%;
  }
}
@media screen and (max-height: 500px) {
  .user-modal.user-modal-small {
    height: 73%;
  }
}
@media screen and (max-height: 365px) {
  .user-modal.user-modal-small {
    height: 100%;
  }
}
</style>
